<template>
    <div class="alert">
        <transition-group name="alert-list">
            <div class="alert__inner" v-for="alert in alerts" :key="alert.id">
                <div class="alert__item" :class="alertClass(alert.type)">
                    <div class="alert__content">
                        <div class="alert__close" @click="hideAlert(alert.id)"></div>
                        <div class="alert__title">
                            {{alert.text}}
                        </div>
                    </div>
                </div>
            </div>
        </transition-group>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        data() {
            return {}
        },
        methods: {
            alertClass(type) {
                let alert = `is-${type}`;
                return alert;
            },
            hideAlert(id) {
                this.$store.dispatch('REMOVE_ALERT', id)
            }

        },
        computed: {
            ...mapGetters([
                'alerts'
            ]),
        }
    }
</script>
<style lang="sass">
    .alert
        width: 380px
        position: fixed
        z-index: 1000
        bottom: 8px
        right: 8px
        display: flex
        flex-direction: column
        +xs
            width: 100%
            right: 0
        &__inner
            width: 100%
            background-color: transparent
            &:not(:first-of-type)
                margin-top: 16px
                +xs
                    margin-top: 8px
        &__item
            background-color: $color--white
            box-shadow: 0px 6px 20px rgba(11, 35, 75, 0.1)
            padding: 20px 30px 20px 45px
            border-radius: 2px
            border-left: 4px solid transparent
            +tr(border-color .3s ease)
            position: relative
            z-index: 1001
            &:before
                content: ''
                z-index: 1
                display: block
                position: absolute
                top: 50%
                transform: translateY(-50%)
                left: 10px
                width: 24px
                height: 24px
                background-size: contain
                background-repeat: no-repeat
                background-position: 50% 50%
            &.is-info
                border-color: $color--blue
                &:before
                    background-image: url('~@/assets/images/alert/info.png')

            &.is-warning
                border-color: #FBC948
                &:before
                    background-image: url('~@/assets/images/alert/warning.png')

            &.is-success
                border-color: $color--green
                &:before
                    background-image: url('~@/assets/images/alert/success.png')

            &.is-error
                border-color: $color--red
                &:before
                    background-image: url('~@/assets/images/alert/error.png')

        &__close
            position: absolute
            right: 10px
            top: 10px
            width: 18px
            height: 18px
            padding: 5px
            opacity: 0.4
            +tr(opacity .3s ease)
            cursor: pointer
            &:hover
                opacity: 0.8
            &:before,
            &:after
                position: absolute
                left: 9px
                top: 3px
                content: ' '
                height: 13px
                width: 2px
                background-color: #0B234B
            &:before
                transform: rotate(45deg)
            &:after
                transform: rotate(-45deg)
    .alert-list-item
        transition: all .6s
    .alert-list-enter,
    .alert-list-leave-to
        opacity: 0
    .alert-list-enter
        transform: translateX(100%)
    .alert-list-leave-to
        transform: translateX(30%)
    .alert-list-move
        transition: transform .4s, opacity .4s
    .alert-list-leave-active
        position: absolute

    .alert-list-leave-active,
    .alert-list-enter-active
        transition: 0.5s


</style>
